import BaseModel from './BaseModel'
import Location from './Location'
import Product from './Product'
import User from './User'
import handleAxiosError from '../utils/handleAxiosError'

export default class Organization extends BaseModel {

  static entity = 'organizations'
  static primaryKey = 'ID'

  declare ID: number
  declare name: string
  declare contactName: string
  declare contactEmail: string
  declare contactPhone: string
  declare live: boolean
  declare locations: Location[]
  declare products: Product[]
  declare users: User[]

  static fields() {

    return {

      // fields
      ID: this.number(null),
      name: this.string(''),
      contactName: this.string(''),
      contactEmail: this.string(''),
      contactPhone: this.string(''),
      live: this.boolean(false),

      // relationships
      locations: this.hasMany(Location, 'organizationID'),
      products: this.hasMany(Product, 'organizationID'),
      users: this.hasMany(User, 'organizationID')

    }

  }

  getDisplayName(): string {
    let name = this.name
    if (!this.live) {
      name += ' (onboarded)'
    }
    return name
  }

  /**
   * @todo Type-hint return value better. (Does Vuetify provide types, e.g. VSelectItem?)
   */
  static getOptions(liveOnly: boolean = false): {title: string, value: number}[] {

    const query = Organization.query()
      .orderBy((organization) => {
        // @ts-ignore
        return organization.getDisplayName().toUpperCase()
      })

    if (liveOnly) {
      query.where('live', true)
    }    

    const options = query.get().map((organization) => {
      return {
        title: organization.getDisplayName(),
        value: organization.ID,
      }
    })

    return options

  }

  /**
   * API methods
   */

  static fetchAll() {
    return this.api()
      .get('/organizations/get_all', {
        dataKey: 'organizations',
      })
      .catch(handleAxiosError)
  }

  static saveNew(payload: CreateOrganizationRequest) {
    return this.api()
      .post('/organizations/create', payload)
      .catch(handleAxiosError)
  }

  static saveExisting(orgID: number, payload: UpdateOrganizationRequest) {
    return this.api()
      .put(`/organizations/organization/${orgID}`, payload)
      .catch(handleAxiosError)
  }

}

export interface CreateOrganizationRequest {
  name: string
  contactName: string
  contactEmail: string
  contactPhone: string
  live: boolean
}

export interface UpdateOrganizationRequest {
  name?: string
  contactName?: string
  contactEmail?: string
  contactPhone?: string
  live?: boolean
}
